var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tile-grid',_vm._l((_vm.getServiceGroupsByPlace(_vm.getPlace)),function(group){return _c('service-group-tile',{key:`${group.id}-${_vm.getPlace.id}`,attrs:{"group":group,"place":_vm.getPlace}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }